import React, { useRef, useState } from 'react';
import TableSearch from 'components/Table/TableSearch';
import Tile from 'components/Tile/Tile';
import Table from 'components/Table';
import gql from 'graphql-tag';
import { Query } from '@apollo/client/react/components';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import TableHeader from 'components/Table/TableHeader';
import { PageContainer } from '../../components/shared/Page/PageContainer';

const GET_POTENTIAL_CUSTOMERS = gql`
  query GET_POTENTIAL_CUSTOMERS($vendorProfileId: ID!) {
    potentialCustomers(vendorProfileId: $vendorProfileId) {
      name
      numOfContacts
      contacts
      numOfOpportunities
      latestTransactionDate
      accountId
    }
  }
`;

export default function CustomersPage() {
  const account = useSelector(state => state.account);
  const searchRef = useRef({ prevSearch: undefined, currentSearch: '' });
  const [savedListSettings, setSavedListSettings] = useState({ page: 0, pageSize: 10 });
  const [pageSizeValue, setPageSizeValue] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const filterPotentialCustomers = potentialCustomers => {
    const { currentSearch } = searchRef.current;

    if (currentSearch.length === 0) {
      return potentialCustomers;
    }

    const lowerCaseSearch = currentSearch.toLowerCase().trim();
    const searchData = potentialCustomers.filter(el => {
      if (typeof el.name === 'string') {
        return (el.name || '').toLowerCase().includes(lowerCaseSearch);
      }

      return false;
    });

    return [...searchData];
  };

  const processPotentialCustomers = potentialCustomers => {
    if (!_.isEmpty(potentialCustomers)) {
      return potentialCustomers.map(customer => ({
        ...customer,
        latestTransactionDate: moment(customer.latestTransactionDate).format('MM/DD/YYYY'),
      }));
    }

    return [];
  };

  return (
    <Query
      context={{ authRequired: true }}
      query={GET_POTENTIAL_CUSTOMERS}
      variables={{ vendorProfileId: account.vendorProfileId }}
      fetchPolicy="no-cache"
    >
      {({ loading, error, data }) => {
        const filteredPotentialCustomers = processPotentialCustomers(
          filterPotentialCustomers(data?.potentialCustomers ?? [])
        ).filter(el => el.name !== null);

        return (
          <PageContainer error={error} loading={loading}>
            <Tile>
              <TableHeader
                filterComps={
                  <>
                    <TableSearch
                      setPageNumber={setPageNumber}
                      setSavedListSettings={setSavedListSettings}
                      searchRef={searchRef}
                      savedListSettings={savedListSettings}
                    />
                  </>
                }
              />

              <Table
                color="primary"
                noDataText={<h3>No results with current settings</h3>}
                className="-highlight"
                getTrProps={(state, rowInfo, column, instance) => ({
                  style: { cursor: 'pointer' },
                  onClick: e => {
                    window.location.href = `/accountDetails/${rowInfo.original.accountId}`;
                  },
                })}
                data={filteredPotentialCustomers}
                columns={[
                  {
                    Header: 'Customer',
                    accessor: 'name',
                  },
                  {
                    Header: 'Contacts',
                    accessor: 'numOfContacts',
                  },
                  {
                    Header: 'Opportunities',
                    accessor: 'numOfOpportunities',
                  },
                  {
                    Header: 'Latest Opportunity',
                    accessor: 'latestTransactionDate',
                    sortMethod: (a, b) => {
                      const dateA = new Date(a).getTime();
                      const dateB = new Date(b).getTime();

                      return dateA - dateB;
                    },
                  },
                ]}
                pageSize={pageSizeValue}
                pageNumber={pageNumber}
                defaultPageSize={savedListSettings.pageSize}
                showPaginationTop={false}
                showPaginationBottom={true}
                onPageChange={changePage => {
                  setPageNumber(changePage);
                }}
                onPageSizeChange={changePageSize => {
                  setPageSizeValue(changePageSize);
                  setPageNumber(0);
                }}
              />
            </Tile>
          </PageContainer>
        );
      }}
    </Query>
  );
}
